@if (payoutProfile?.length) {
  <div class="px-3 d-none d-md-block" data-zid="payout-data-table">
    <table class="table-simple">
      <thead>
        <tr class="zero-surface grey-800">
          <th class="zero-text p-small-reg text-right">
            {{ 'instrument-detail.derivative-data-payout-profile.underlyingPerformance' | transloco }}
          </th>
          <th class="zero-text p-small-reg text-right">
            {{ 'instrument-detail.derivative-data-payout-profile.underlyingPrice' | transloco }}
          </th>
          <th class="zero-text p-small-reg text-right">
            {{ 'instrument-detail.derivative-data-payout-profile.derivativePrice' | transloco }}
          </th>
          <th class="zero-text p-small-reg text-right">
            {{ 'instrument-detail.derivative-data-payout-profile.derivativePerformance' | transloco }}
          </th>
          <th class="zero-text p-small-reg text-right">{{ 'instrument-detail.derivative-data-payout-profile.advantage' | transloco }}</th>
        </tr>
      </thead>
      <tbody>
        @for (item of payoutProfile; track $index) {
          <tr>
            <td class="zero-text p-small-reg">
              <ng-container
                *ngTemplateOutlet="valueOrDash; context: { value: item.underlyingPerformance, style: item.underlyingPerformanceStyle }"
              />
            </td>
            <td class="zero-text p-small-reg">
              <ng-container *ngTemplateOutlet="valueOrDash; context: { value: item.underlyingPrice }" />
            </td>
            <td class="zero-text p-small-reg">
              <ng-container *ngTemplateOutlet="valueOrDash; context: { value: item.derivativePrice }" />
            </td>
            <td class="zero-text p-small-reg">
              <ng-container *ngTemplateOutlet="valueOrDash; context: { value: item.derivativePerformance }" />
            </td>
            <td class="zero-text p-small-bold">
              <ng-container *ngTemplateOutlet="valueOrDash; context: { value: item.advantage, style: item?.advantageStyle }" />
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="d-block d-md-none pt-3">
    @for (item of payoutProfile; track $index) {
      <div class="row">
        <div class="col-6">
          {{ 'instrument-detail.derivative-data-payout-profile.underlyingPerformance' | transloco }}
        </div>
        <div class="col-6 text-right">
          <ng-container
            *ngTemplateOutlet="valueOrDash; context: { value: item.underlyingPerformance, style: item.underlyingPerformanceStyle }"
          />
        </div>
      </div>
      <hr />

      <div class="row">
        <div class="col-6">
          {{ 'instrument-detail.derivative-data-payout-profile.derivativePerformance' | transloco }}
        </div>
        <div class="col-6 text-right">
          <b>
            <ng-container *ngTemplateOutlet="valueOrDash; context: { value: item.derivativePerformance }" />
          </b>
        </div>
      </div>
      <hr />

      <div class="row">
        <div class="col-6">
          {{ 'instrument-detail.derivative-data-payout-profile.advantage' | transloco }}
        </div>
        <div class="col-6 text-right">
          <ng-container *ngTemplateOutlet="valueOrDash; context: { value: item.advantage, style: item?.advantageStyle }" />
        </div>
      </div>
      <hr class="bold" />
    }
  </div>
}

<ng-template #valueOrDash let-value="value" let-style="style">
  @if (value) {
    <div class="zero-text text-right" [ngClass]="style ? 'course-' + style : ''">
      {{ value }}
    </div>
  } @else {
    <div>&mdash;</div>
  }
</ng-template>
